import * as React from 'react';
import type { ISearchGnavInputField } from './SearchGnavInputField';
import { events } from '@estee/elc-service-bus';
import { root } from '@estee/elc-universal-utils';

export const SearchGnavInputFieldIcon: React.FC<ISearchGnavInputField> = (props) => {
    const [shouldShow, setShouldShow] = React.useState(false);
    const [openOverlay, setOpenOverlay] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    const componentRef = React.useRef<React.ComponentType<ISearchGnavInputField> | null>(null);
    const Component = componentRef.current;

    React.useEffect(() => {
        const onSearchShouldRender = (openOverlay?: boolean) => {
            setShouldShow(true);
            setOpenOverlay(!!openOverlay)
        };
        root.GlobalServiceBus.on(events.SEARCH_SHOULD_RENDER, onSearchShouldRender);
    }, []);

    React.useEffect(() => {
        if (shouldShow) {
            import('./DynamicSearchGnavInput').then(
                (m) => {
                    componentRef.current = m.default;
                    setLoaded(true);
                    root.GlobalServiceBus.emit(events.SEARCH_ICON_HIDE);
                }
            );
        }
    }, [shouldShow]);

    return (
        <>
            {loaded && Component && (
                <Component {...props} initiallyOpen={openOverlay}/>
            )}
        </>
    );
};
